module.exports = __webpack_public_path__ + "static/media/logo-menu.40542520.png";